var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "TopBar" },
        [
          _c("router-link", { attrs: { to: _vm.navigateToList } }, [
            _c("img", {
              attrs: {
                src: require("@/assets/images/logo-dostartu-white.svg"),
                alt: "Logo dostartu",
              },
            }),
          ]),
          _c("router-link", { attrs: { to: _vm.navigateToList } }, [
            _c("img", {
              attrs: {
                src: require("@/assets/images/icons/home.svg"),
                alt: "Logo dostartu",
              },
            }),
          ]),
        ],
        1
      ),
      _c("scanner-q-r", {
        ref: "scanner",
        attrs: { "header-offset": 48 },
        on: { decoded: _vm.onDecoded, error: _vm.onScanError },
      }),
      _c(
        "div",
        { staticClass: "search-wrapper", on: { click: _vm.openSearchView } },
        [_vm._m(0)]
      ),
      _vm.showSearchView
        ? _c("div", { staticClass: "search-view" }, [
            _c(
              "div",
              { staticClass: "search-view-topbar" },
              [
                _c("router-link", { attrs: { to: _vm.navigateToList } }, [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/images/logo-dostartu-white.svg"),
                      alt: "Logo dostartu",
                    },
                  }),
                ]),
              ],
              1
            ),
            _c("div", { staticClass: "search-input-container" }, [
              _c("div", { staticClass: "search-input-wrapper" }, [
                _c("i", { staticClass: "fas fa-search" }),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.searchQuery,
                      expression: "searchQuery",
                    },
                  ],
                  ref: "searchInput",
                  staticClass: "search-input",
                  attrs: {
                    type: "text",
                    placeholder: "Wyszukaj uczestnika lub nr startowy...",
                  },
                  domProps: { value: _vm.searchQuery },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.searchQuery = $event.target.value
                    },
                  },
                }),
              ]),
            ]),
            _c("div", { staticClass: "participants-list-container" }, [
              _c(
                "div",
                { staticClass: "participants-list" },
                _vm._l(_vm.filteredParticipants, function (participant) {
                  return _c(
                    "div",
                    {
                      key:
                        participant.id ||
                        participant.playerNumber +
                          "-" +
                          participant.firstname +
                          "-" +
                          participant.lastname,
                      staticClass: "participant-item",
                      on: {
                        click: function ($event) {
                          return _vm.selectParticipant(participant)
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "participant-info" }, [
                        _c("div", { staticClass: "participant-name" }, [
                          _vm._v(
                            _vm._s(participant.firstname) +
                              " " +
                              _vm._s(participant.lastname)
                          ),
                        ]),
                        _c("div", { staticClass: "participant-number" }, [
                          _vm._v(_vm._s(participant.playerNumber)),
                        ]),
                        _c("i", { staticClass: "fas fa-caret-right" }),
                      ]),
                    ]
                  )
                }),
                0
              ),
            ]),
            _c(
              "div",
              {
                staticClass: "search-view-close",
                on: { click: _vm.closeSearchView },
              },
              [_c("i", { staticClass: "fas fa-times" })]
            ),
          ])
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "info-box",
          class: { "info-box--shown": _vm.showInfoBox },
        },
        [
          _vm.infoLoading
            ? _c("div", { staticClass: "info-box-header" }, [_vm._m(1)])
            : _vm.infoStatus === "noCamera"
            ? _c(
                "div",
                { staticClass: "info-box-header info-box-header--warning" },
                [
                  _c(
                    "div",
                    [
                      _c("exclamation-mark", { attrs: { fill: "#455A64" } }),
                      _c("b", [_vm._v("Brak dostępnej kamery")]),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    [
                      _c(
                        "base-button",
                        { attrs: { btn2: "" }, on: { click: _vm.tryAgain } },
                        [_vm._v(" spróbuj ponownie ")]
                      ),
                    ],
                    1
                  ),
                ]
              )
            : _vm.infoStatus === "permission"
            ? _c(
                "div",
                { staticClass: "info-box-header info-box-header--warning" },
                [
                  _c(
                    "div",
                    [
                      _c("exclamation-mark", { attrs: { fill: "#455A64" } }),
                      _c("b", [_vm._v("Odmowa dostępu do kamery")]),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    [
                      _c(
                        "base-button",
                        { attrs: { btn2: "" }, on: { click: _vm.tryAgain } },
                        [_vm._v(" spróbuj ponownie ")]
                      ),
                    ],
                    1
                  ),
                ]
              )
            : _vm.infoStatus === "insecure"
            ? _c(
                "div",
                { staticClass: "info-box-header info-box-header--warning" },
                [
                  _c(
                    "div",
                    [
                      _c("exclamation-mark", { attrs: { fill: "#455A64" } }),
                      _c("b", [
                        _vm._v("Wymagany HTTPS lub uruchom na localhost"),
                      ]),
                    ],
                    1
                  ),
                ]
              )
            : [
                _vm.infoStatus === "success"
                  ? _c(
                      "div",
                      {
                        staticClass: "info-box-header info-box-header--success",
                      },
                      [
                        _c(
                          "div",
                          [
                            _c("checkmark-circle"),
                            _c("b", [
                              _vm._v("Wszystko w porządku, możesz wydać numer"),
                            ]),
                          ],
                          1
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm.infoStatus === "issued"
                  ? _c(
                      "div",
                      {
                        staticClass: "info-box-header info-box-header--success",
                      },
                      [
                        _c(
                          "div",
                          [
                            _c("checkmark-circle"),
                            _c("b", [_vm._v("Numer startowy został wydany")]),
                          ],
                          1
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm.infoStatus === "alreadyIssued"
                  ? _c(
                      "div",
                      { staticClass: "info-box-header info-box-header--error" },
                      [
                        _c(
                          "div",
                          [
                            _c("exclamation-triangle"),
                            _c("b", [
                              _vm._v("Numer startowy został już wydany"),
                            ]),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticStyle: { width: "100%" } },
                          [
                            _c(
                              "base-button",
                              {
                                staticStyle: { width: "100%", color: "white" },
                                attrs: { btn4: "" },
                                on: { click: _vm.revert },
                              },
                              [_vm._v("Cofnij wydanie numeru")]
                            ),
                          ],
                          1
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm.infoStatus === "noPlayerNumber"
                  ? _c(
                      "div",
                      { staticClass: "info-box-header info-box-header--error" },
                      [
                        _c(
                          "div",
                          [
                            _c("exclamation-triangle"),
                            _c("b", [_vm._v("Brak Numeru startowego")]),
                          ],
                          1
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm.infoStatus === "reverted"
                  ? _c("div", { staticClass: "info-box-header" }, [
                      _c(
                        "div",
                        [
                          _c("checkmark-circle", {
                            attrs: { fill: "#455A64" },
                          }),
                          _c("b", [
                            _vm._v("Wydanie numeru zostało cofnięnie."),
                          ]),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
                _vm.infoStatus === "noFee"
                  ? _c(
                      "div",
                      { staticClass: "info-box-header info-box-header--error" },
                      [
                        _c(
                          "div",
                          [
                            _c("exclamation-triangle"),
                            _c("b", [_vm._v("Brak opłaty startowej")]),
                          ],
                          1
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm.infoStatus === "warning" || _vm.infoStatus === "error"
                  ? _c(
                      "div",
                      {
                        staticClass: "info-box-header info-box-header--warning",
                      },
                      [
                        _c(
                          "div",
                          [
                            _c("exclamation-mark", {
                              attrs: { fill: "#455A64" },
                            }),
                            _c("b", [_vm._v("Niepoprawny kod QR")]),
                          ],
                          1
                        ),
                      ]
                    )
                  : _vm._e(),
                _c(
                  "div",
                  {
                    ref: "infoContent",
                    staticClass: "info-box-content",
                    class: { "has-scroll": _vm.contentScrollable },
                    on: { scroll: _vm.onContentScroll },
                  },
                  [
                    _vm.infoStatus === "noPlayerNumber"
                      ? _c("validation-observer", {
                          ref: "playerNumberFormObserver",
                          attrs: { tag: "div" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function ({ handleSubmit }) {
                                  return [
                                    _c(
                                      "form",
                                      {
                                        staticClass: "row add-person",
                                        on: {
                                          submit: function ($event) {
                                            $event.preventDefault()
                                            return handleSubmit(_vm.add)
                                          },
                                        },
                                      },
                                      [
                                        _c("validation-provider", {
                                          staticClass: "scroll-margin",
                                          attrs: {
                                            name: "playerNumber",
                                            rules: "required",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function ({ errors }) {
                                                  return [
                                                    _c("base-input-text", {
                                                      staticClass: "form-input",
                                                      attrs: {
                                                        type: "number",
                                                        label: "Numer startowy",
                                                        error: errors[0],
                                                      },
                                                      on: {
                                                        "update:error":
                                                          function ($event) {
                                                            return _vm.$set(
                                                              errors,
                                                              0,
                                                              $event
                                                            )
                                                          },
                                                      },
                                                      model: {
                                                        value: _vm.playerNumber,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.playerNumber = $$v
                                                        },
                                                        expression:
                                                          "playerNumber",
                                                      },
                                                    }),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            639685241
                          ),
                        })
                      : _c("div", [
                          _c("div", [
                            _c("div", { staticClass: "label" }, [
                              _vm._v("Numer startowy"),
                            ]),
                            _c("div", { staticClass: "text text-lg" }, [
                              _vm._v(_vm._s(_vm.info.startNumber || "-")),
                            ]),
                          ]),
                        ]),
                    _c("div", [
                      _c("div", [
                        _c("div", { staticClass: "label" }, [
                          _vm._v("Uczestnik"),
                        ]),
                        _c("div", { staticClass: "text text-lg" }, [
                          _vm._v(_vm._s(_vm.info.participantName || "-")),
                        ]),
                      ]),
                    ]),
                    _c("div", [
                      _c("div", [
                        _c("div", { staticClass: "label" }, [
                          _vm._v("Klasyfikacja"),
                        ]),
                        _c("div", { staticClass: "text" }, [
                          _vm._v(
                            _vm._s(
                              _vm.classification?.namePl ||
                                _vm.info.classification ||
                                "-"
                            )
                          ),
                        ]),
                      ]),
                    ]),
                    _c("div", [
                      _c("div", [
                        _c("div", { staticClass: "label" }, [
                          _vm._v("Nr chipa"),
                        ]),
                        _c("div", { staticClass: "text" }, [
                          _vm._v(_vm._s(_vm.info.chipNumber || "-")),
                        ]),
                      ]),
                      _c("div", { staticClass: "flex-end" }, [
                        _c("div", { staticClass: "label" }, [_vm._v("Nr GPS")]),
                        _c("div", { staticClass: "text" }, [
                          _vm._v(_vm._s(_vm.info.gpsNumber || "-")),
                        ]),
                      ]),
                    ]),
                    _vm.info?.shopSales && _vm.info.shopSales.length > 0
                      ? [
                          _c("hr"),
                          _c("div", [
                            _c("div", [
                              _c("div", { staticClass: "label" }, [
                                _vm._v("Pakiet startowy"),
                              ]),
                              _c(
                                "div",
                                { staticClass: "shop-item-wrap" },
                                _vm._l(_vm.info.shopSales, function (shop) {
                                  return _c(
                                    "div",
                                    { staticClass: "shop-item" },
                                    [
                                      _c("div", [
                                        _c("div", { staticClass: "label" }, [
                                          _vm._v("x" + _vm._s(shop.items)),
                                        ]),
                                        _c("div", { staticClass: "text" }, [
                                          _vm._v(_vm._s(shop.shopProduct)),
                                        ]),
                                      ]),
                                      _c("div", [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "label",
                                            staticStyle: {
                                              "text-align": "right",
                                            },
                                          },
                                          [_vm._v(_vm._s(shop.model))]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "text",
                                            staticStyle: {
                                              "text-align": "right",
                                            },
                                          },
                                          [
                                            !shop.pay
                                              ? _c(
                                                  "small",
                                                  {
                                                    staticStyle: {
                                                      color:
                                                        "var(--color-pinky-red, red)",
                                                    },
                                                  },
                                                  [_vm._v("niezapłacone")]
                                                )
                                              : _vm._e(),
                                            _vm._v(
                                              " " + _vm._s(shop.amount) + " "
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  )
                                }),
                                0
                              ),
                            ]),
                          ]),
                        ]
                      : _vm._e(),
                    _vm.info?.notes
                      ? [
                          _c("hr"),
                          _c("div", [
                            _c("div", [
                              _c("div", { staticClass: "label" }, [
                                _vm._v("Notatka"),
                              ]),
                              _c("div", { staticClass: "text" }, [
                                _vm._v(_vm._s(_vm.info.notes || "-")),
                              ]),
                            ]),
                          ]),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
                _c(
                  "div",
                  {
                    staticClass: "info-box-footer",
                    style: {
                      "--shadow-opacity": _vm.contentScrollable
                        ? _vm.shadowOpacity
                        : 0,
                      "--shadow-height": _vm.contentScrollable
                        ? _vm.shadowHeight + "px"
                        : "0px",
                    },
                  },
                  [
                    _vm.infoStatus === "noPlayerNumber"
                      ? _c(
                          "base-button",
                          {
                            staticStyle: { width: "100%" },
                            attrs: { btn1: "" },
                            on: { click: _vm.setPlayerNumber },
                          },
                          [_vm._v("Ustaw numer i wydaj pakiet")]
                        )
                      : _vm._e(),
                    _vm.infoStatus === "success"
                      ? _c(
                          "base-button",
                          {
                            staticStyle: { width: "100%" },
                            attrs: { btn1: "" },
                            on: { click: _vm.issueNumber },
                          },
                          [_vm._v("Wydaj numer")]
                        )
                      : _vm._e(),
                    _c(
                      "base-button",
                      { attrs: { btn4: "" }, on: { click: _vm.closeInfoBox } },
                      [_vm._v(" zamknij ")]
                    ),
                  ],
                  1
                ),
              ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "search-trigger" }, [
      _c("i", { staticClass: "fas fa-search" }),
      _c("span", [_vm._v("Wyszukaj uczestnika lub nr startowy....")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticStyle: { display: "flex", "align-items": "center", gap: "12px" },
      },
      [
        _c("span", { staticClass: "spinner spinner--small" }),
        _c("b", [_vm._v("Synchronizacja danych…")]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }